<template>
  <div class="wrap-box">
    <template v-if="isAutoCreate || isAuto && item.f_user_idx == myinfo.uid">
      <div class="leftright" style="margin-bottom: 5px; margin-top: 20px;">
        <div class="auto_noti_title_wrapper leftright">
          <div class="auto_noti_title">{{u.format($t('notify.auto_noti_title'), autoIndex)}}</div>
          <CSwitch
            v-model="isAutoEnable"
            @change="changeAutoNotiState"
          />
        </div>
        <div v-if="!isAutoCreate && Object.keys(item).includes('f_remain_notify_cnt')" class="center">
          <div class="available_notify" style="margin-right: 15px;">
            {{u.format($t('group.available_notify'),  item.f_remain_notify_cnt)}}
          </div>
          <b-button class="small_btn_grey small_btn_text" @click="deleteAuto">{{$t('admin_ads.delete')}}</b-button>
        </div>
      </div>
    </template>
    <div class='noti_wrap'>
      <template v-if="isAutoCreate">
        <div class="noti_item btn_auto_create_txt btn_auto_create center" style="height: 51px;"
             @click="() => {
               let _data = {
                 f_auto_enable: self.isAutoEnable,
                 f_auto_time: self.time,
                 f_auto_interval: self.interval,
                 };
               // self.init();
               self.$emit('click', _data);
             }"
        >
          {{$t('notify.create_auto_notify')}}
        </div>
      </template>
      <template v-else>
        <div :class="['noti_item', item.f_select ? 'selected':'', item.f_made == 'Y' ? 'made_item':'']"
             @click="onclick"
             @mousedown="on_down"
             @mouseup="on_up"
        >
          <div class="leftright">
            <div style="display: flex;align-items: center">
              <div v-if="item.f_made == 'N'" style="position: relative">
                <b-img :src="require('../../assets/image/ic_alarm@2x.png')" style="height: 1.2em;vertical-align: text-top" />
                <b-img v-if="!hideRedDot && item.f_auto == 'N' && item.f_read == 'N'"
                       :src="require('../../assets/image/ic_dot_red.png')" class="noti_badge"/>
              </div>
              <div v-if="item.f_made == 'Y'" style="position: relative;margin-bottom: 2px;">
<!--                <div class="align-horizontal">
                  <span class="made_badge mr-1">메이드+</span>
                  <b-img v-if="!hideRedDot && item.f_auto == 'N' && item.f_read == 'N'"
                         class="noti_badge" :src="require('../../assets/image/ic_dot_red.png')"/>
                </div>-->
                <div class="align-horizontal cost_item">
                  <div class="badge"
                       v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.TRADING) > -1 && showTrading"
                       :style="{backgroundColor: $c.Color.$trading}">
                    {{
                      item.f_site_type == "O"
                        ? $t("site_detail.parcel_out")
                        : $t("interest.trading")
                    }}
                  </div>
                  <div class="badge"
                       v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.CHARTER) > -1 && showCharter"
                       :style="{backgroundColor: $c.Color.$charter}" >
                    {{ $t("interest.charter") }}
                  </div>
                  <div class="badge"
                       v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.MONTHLY) > -1 && showMonth"
                       :style="{backgroundColor: $c.Color.$monthly}" >
                    {{ $t("interest.monthly") }}
                  </div>
                  <div class="badge"
                       v-if="maemulTypes.indexOf($c.MAEMUL_TYPE.INVEST) > -1 && showInvestment"
                       :style="{backgroundColor: $c.Color.$invest}" >
                    {{ $t("interest.invest") }}
                  </div>
                </div>
              </div>
              <div class="noti_title">{{item.f_site_name}}</div>
            </div>
            <div class="noti_time">{{!isAuto ? renderTime(item.f_reg_time) : $t('admin.update') +' ' + renderTime(item.f_update_time, true)}}</div>
          </div>
          <div class="noti_content">{{item.f_title}}</div>
        </div>
      </template>
    </div>
    <div v-if="isAuto && item.f_user_idx == myinfo.uid || isAutoCreate" style="margin:15px 7px;">
      <div class="leftright">
        <div class="auto_noti_txt">
          {{$t('notify.auto_noti_interval')}}
        </div>
        <b-button-group class="btn_group_wrapper">
          <b-button @click="setAutoInterval('E')" variant="white" :class="['btn1 btn_txt1', interval == 'E' ? isAutoEnable == 'Y' ?'btn_active':'btn_active_disable':'']">
            {{$t('notify.auto_noti_every_day')}}
          </b-button>
          <b-button @click="setAutoInterval('3')" variant="white" :class="['btn1 btn_txt1', interval == '3' ? isAutoEnable == 'Y' ?'btn_active':'btn_active_disable':'']">
            {{$t('notify.auto_noti_3_day')}}
          </b-button>
          <b-button @click="setAutoInterval('5')" variant="white" :class="['btn1 btn_txt1', interval == '5' ?isAutoEnable == 'Y' ?'btn_active':'btn_active_disable':'']">
            {{$t('notify.auto_noti_5_day')}}
          </b-button>
        </b-button-group>
      </div>
      <div class="leftright" style="margin: 20px 0;">
        <div class="auto_noti_txt" >
          {{$t('notify.auto_noti_time')}}
        </div>
        <b-form-timepicker v-model="time"
                           button-only
                           button-variant="time-no-padding"
                           locale="ko"
                           :class="['time_wrapper', isAutoEnable == 'Y'?'':'btn_active_disable']"
                           :disabled="isAutoEnable != 'Y'"
                           right
                           @hidden="changeAutoNotiState"
        >
          <div slot="button-content">
            <div class="time">{{time.substr(0,5).replaceAll(':', ' : ')}}</div>
          </div>
        </b-form-timepicker>
      </div>
    </div>
    <div v-if="isAuto && item.f_user_idx == myinfo.uid" style="margin: 10px -15px; background-color: #f4f5f6; height: 4px;width: 100%;"/>
  </div>
</template>

<script>
import moment from "moment";
import CSwitch from "./CSwitch";
import Utils from "../../config/utils";
const u = require('util');


export default {
  name: "NotifyItem",
  props:['item','isAuto','isAutoCreate', 'autoIndex', 'hideRedDot'],
  components:{
    CSwitch,
  },
  inject: ["eventBus"],
  data() {
    return {
      util: Utils,
      self: this,
      u:u,
      timeID:0,
      long:false,
      isAutoEnable:!Utils.isEmpty(this.item) ? this.item.f_auto_enable : 'N',
      time:!Utils.isEmpty(this.item) ? this.item.f_auto_time: '00:00:00',
      interval:!Utils.isEmpty(this.item) ? this.item.f_auto_interval :'E',
      showTrading: true,
      showCharter: true,
      showInvestment: true,
      showMonth: true,
    }
  },
  computed:{
    maemulTypes: function () {
      var maemulTypes = [];
      if (this.item.f_made === 'Y') {
        if (this.item.f_site_type == 'G') {
          maemulTypes = !this.item.f_transaction_type ? [] : this.item.f_transaction_type.split(',')
            .filter(it => {
              return it != '';
            })
            .map(it => {
              return Number(it);
            });
        } else if (this.item.f_site_type == 'O') {
          if (this.item.f_ho_list != undefined && this.item.f_ho_list.length != 0) {
            this.item.f_ho_list.forEach((ho) => {
              ho.f_trans_type.split(',')
                .filter(it => {
                  return it != '';
                }).forEach(it => {
                if (maemulTypes.indexOf(Number(it)) < 0)
                  maemulTypes.push(Number(it))
              })
            })
          } else {
            maemulTypes = !this.item.f_transaction_type ? [] : this.item.f_transaction_type.split(',')
              .filter(it => {
                return it != '';
              })
              .map(it => {
                return Number(it);
              });
          }
        }
        let item_ho_list = this.item.f_ho_list;
        if (item_ho_list.length >= 1 && this.item.f_site_type == 'O') {
          this.available_ho_cnt = item_ho_list.filter(it => {return it.f_complete == 'N'}).length;
          let sale_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_sale_price))
          let collateral_price_list = item_ho_list.filter(it => {return it.f_complete == 'N'  && it.f_site_inquire_price != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.TRADING))}).map(it => Number(it.f_collateral_price))
          let charter_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_charter != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.CHARTER))}).map(it => Number(it.f_charter_price))
          let invest_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_investment != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.INVEST))}).map(it => Number(it.f_investment_price))
          let month_rent_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_month != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.MONTHLY))}).map(it => Number(it.f_monthly_rent))
          let month_rent_deposit_price_list = item_ho_list.filter(it => {return it.f_complete == 'N' && it.f_site_inquire_month != 'Y' && it.f_trans_type.split(',').includes(String(this.$c.MAEMUL_TYPE.MONTHLY))}).map(it => Number(it.f_monthly_rent_deposit))

          this.item.f_sale_price_min = Math.min(...sale_price_list)
          this.item.f_sale_price_max = Math.max(...sale_price_list)
          this.item.f_charter_price_min = Math.min(...charter_price_list)
          this.item.f_charter_price_max = Math.max(...charter_price_list)
          this.item.f_invest_price_min = Math.min(...invest_price_list)
          this.item.f_invest_price_max = Math.max(...invest_price_list)
          this.f_monthly_rent_deposit_min = Math.min(...month_rent_deposit_price_list) // 월세보증금
          this.f_monthly_rent_deposit_max = Math.max(...month_rent_deposit_price_list) // 월세보증금
          this.f_monthly_rent_min = Math.min(...month_rent_price_list) // 월세
          this.f_monthly_rent_max = Math.max(...month_rent_price_list) // 월세
          if (this.f_monthly_rent_deposit_min != Infinity && this.f_monthly_rent_deposit_max != -Infinity
            && this.f_monthly_rent_min != Infinity && this.f_monthly_rent_max != -Infinity
            && (this.f_monthly_rent_deposit_min !== this.f_monthly_rent_deposit_max || this.f_monthly_rent_min !== this.f_monthly_rent_max)
          ) {
            this.month_simple = true
          } else {
            this.month_simple = false
          }

          this.item.f_collateral_price = Math.max(...collateral_price_list) // 담보금
          this.item.f_site_inquire_price = item_ho_list.filter(it => {return it.f_complete == 'N'})
            .some(it => it.f_trans_type.split(',').includes('0') && it.f_site_inquire_price == 'Y') ? 'Y' : 'N'
          this.item.f_site_inquire_charter = item_ho_list.filter(it => {return it.f_complete == 'N'})
            .some(it => it.f_trans_type.split(',').includes('1') && it.f_site_inquire_charter == 'Y') ? 'Y' : 'N'
          this.item.f_site_inquire_investment = item_ho_list.filter(it => {return it.f_complete == 'N'})
            .some(it => it.f_trans_type.split(',').includes('2') && it.f_site_inquire_investment == 'Y') ? 'Y' : 'N'
          this.item.f_site_inquire_month = item_ho_list.filter(it => {return it.f_complete == 'N'})
            .some(it => it.f_trans_type.split(',').includes('3') && it.f_site_inquire_month == 'Y') ? 'Y' : 'N'
        }
        if (this.item.f_site_type != 'O') {
          this.f_monthly_rent_min = item.f_monthly_rent_min // 월세보증금
          this.f_monthly_rent_max = item.f_monthly_rent_max // 월세
        }

        if (this.item.f_sale_price_min == Infinity && this.item.f_sale_price_max == -Infinity && this.item.f_site_inquire_price == 'N') {
          this.showTrading = false;
        } else {
          this.showTrading = true;
        }

        if (this.item.f_charter_price_min == Infinity && this.item.f_charter_price_max == -Infinity && this.item.f_site_inquire_charter == 'N') {
          this.showCharter = false;
        } else {
          this.showCharter = true;
        }

        if (this.item.f_invest_price_min == Infinity && this.item.f_invest_price_max ==  -Infinity && this.item.f_site_inquire_investment == 'N') {
          this.showInvestment = false;
        } else {
          this.showInvestment = true;
        }
        if (this.f_monthly_rent_min == Infinity && this.f_monthly_rent_max ==  -Infinity && this.item.f_site_inquire_month == 'N') {
          this.showMonth = false;
        } else {
          this.showMonth = true;
        }
      }
      return maemulTypes;
    },
  },
  methods:{
    init(){
      // this.isAuto =
      this.isAutoEnable = 'N';
      this.time = '00:00';
      this.interval = 'E';
    },
    onclick(){
      if (!this.long){
        this.$emit('click');
      }
    },
    on_down(){
      var self = this;
      this.timeID = setTimeout(function (){
        self.$emit('longClick');
        self.long = true;
      }, 500);
    },
    on_up(){
      var self = this;
      setTimeout(function (){
        self.long = false;
      }, 100);
      clearTimeout(this.timeID);
    },

    renderTime(date_time) {
      if (moment(date_time).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')) {
        return moment(date_time).format('HH:mm');
      } else {
        return moment(date_time).format('MM/DD');
      }
    },

    changeAutoNotiState(state=null){
      this.eventBus.$emit("checkTicketAvailable", ()=>{
        if (!this.isAutoCreate) {
          let param = {
            notify_idx: this.item.f_idx,
            autoEnable: !Utils.isEmpty(state) ? state : this.isAutoEnable,
            autoInterval: this.interval,
            autoTime: this.time.substr(0,5),
          };
          Utils.requestPost(
            this.$c.API.Notify.updateAutoNotify,
            param
          ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
              if (!Utils.isEmpty(state)) {
                this.isAutoEnable = this.isAutoEnable === 'Y' ? 'N' : 'Y';
              }
              Utils.toast(this, this.$t('admin_point_setting.msg_update_success'));
            } else {
              Utils.toast(this, result.msg);
            }
          });
        }else{
          this.$store.commit('setAutoNotificationInfo', {
            f_auto_enable: this.isAutoEnable,
            f_auto_time: this.time,
            f_auto_interval: this.interval
          });
          if (!Utils.isEmpty(state)){
            this.isAutoEnable = this.isAutoEnable === 'Y' ? 'N' : 'Y';
          }
        }
      });
    },

    setAutoInterval(interval){
      if (this.isAutoEnable == 'Y'){
        this.interval = interval;
        this.changeAutoNotiState();
      }
    },

    deleteAuto(){
      Utils.requestPost(
          this.$c.API.Notify.removeNotify,
          {
            idx_list: JSON.stringify([this.item.f_idx]),
          },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          Utils.toast(this, this.$t('common.delete_success'));
          this.$emit('deleteAuto', this.autoIndex -1);
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/vars";

.noti_content{
  color: $black;
  font-size: $fs_17;
  font-family: $korean_gd_13_r;
  padding-left: 4px;
  line-height: 2;
}

.noti_badge{
  width: 3px;
  position:absolute;
  top: 5px;
  right: -1px
}

.made_text{
  color: $white;
  font-size: $fs_10;
  font-family: $korean_gd_17_r
}

//.time_wrapper{
//  padding:4px 10px;
//  background-color: $c_457fff;
//  border-width: 0.5px;
//  border-color: #e8e7e7;
//  border-radius: 8px;
//  color: $white;
//  font-size: $fs_22;
//  font-family: $korean_gd_11_r;
//}

.noti_title{
  margin-left: 0.3em;
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 210px;
  white-space: nowrap;
}

.noti_time{
  color:#9f9f9f;
  font-size: $fs_14;
  font-family: $korean_gd_12_r;
  margin-right: 6px;
}

.noti_item{
  height: 75px;
  border-radius: 5px;
  background-color: $white;
  border: solid 0.5px #dfdcdc;
  padding:9px 9px 5px;
  overflow: hidden;
  box-shadow: 0 6px 6px rgba(0,0,0,0.08);

  &.made_item {
    //border: solid 0.8px #457fff;

    .noti_time {
      //color: #457fff;
    }
  }
}

.cost_item {
  .badge {
    margin-right: 3px;
    color: white;
    height: 22px;
    font-family: 'KoreanGD14R';
    font-weight: 100;
    padding-top: 4px;
    width: 40px;
    border-radius: 0.17rem;
    font-size: 14px;
  }
}

.noti_wrap{
  margin-bottom: 5px;
}

.wrap-box{
  margin: 1px 0px;
}

.auto_noti_title_wrapper{margin:0 5px 7px 5px;}
.auto_noti_title{
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_16_r;
  margin-right: 10px;
}
.auto_noti_txt{
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}
.time_wrapper{
  padding: 4px 15px;
  background-color: $c_457fff;
  border-radius: 9px;
  // justify-content: 'center'
}
.time{
  color: $white;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
  // fontWeight: 'bold'
}
.btn_group_wrapper{
  overflow: hidden;
  border-radius: 5px;
  background-color: $white;
}
.btn_active{
  background-color: $c_457fff!important;
}
.btn_active_disable{
  background-color: #abacae!important;
}
.btn1{
  width: 60px;
  height: 40px;
  background-color: #edf4fe;
  padding: 3px;
  align-items: center;
  justify-content: center;
}

.btn1:active{
  box-shadow: none;
}
.btn_txt1{
  color: $white; font-size: $fs_18; font-family: $korean_gd_15_r;
}
.btn_auto_create{
  background-color: $white;
  align-items: center;
  justify-content: center;
}
.btn_auto_create_txt{
  color: $c_457fff;
  font-size: $fs_18;
  font-family: $korean_gd_17_r;
}
.small_btn_grey{
  width: 60px;
  height: 32px;
  align-items: center;
  justify-content: center;
  background-color: $c_cacbcd;
  border-radius: 2px;
}
.small_btn_text{ color: $white; font-size: $fs_18; font-family: $korean_gd_15_r;padding-top: 4px; }
.available_notify{
  color: #0660e2;
  font-size: $fs_18;
  font-family: $korean_gd_16_r;
  text-decoration: underline;
}
.made_badge {
  color: white;
  background-color: $trading1;
  font-size: $fs_16;
  font-family: $korean_gd_16_r;
  padding: 0 5px;
  border-radius: 3px;
  width: 61px;
}

//.btn-time{
//  border-style: solid;
//  border-width: 0.5px;
//  border-color: #e8e7e7;
//  border-radius: 8px;
//}


</style>



// WEBPACK FOOTER //
// src/components/controls/NotifyItem.vue